import axios from 'axios'

let _svc
let _that

export default {
  GetPosten: () => {
    try {
      return _svc.get('Postcode')
    } catch {
      return null
    }
  },

  Init: (that) => {
    _that = that

    _svc = axios.create({
      baseURL: process.env.VUE_APP_API_URL
    })

    _svc.interceptors.response.use(
      response => response,
      error => {
        _that.ErrorMixin_HandleError(error)
      }
    )
  }
}
